// import Header from './Header';
// import {
//     CSSTransition,
//     TransitionGroup,
// } from 'react-transition-group';
import { createBrowserHistory } from 'history'
import commonStore from '../stores/commonStore';
import ScrollMemory from 'react-router-scroll-memory';
import '../styles/app.css';
import { Progress } from 'react-sweet-progress';
import "react-sweet-progress/lib/style.css";
import Loader from 'react-loader-spinner'
import { BounceLoader } from 'react-spinners';
import { Line, Circle } from 'rc-progress';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

import Login from "./Home/onboarding/login";
import Footer from './layout/footer';
import React from 'react';
import {
    BrowserRouter as Router,
    Link,
    withRouter,
    Route,
    Switch,
} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { inject, observer } from 'mobx-react';
import LandingPage from './Home/profile/landingPage';
import Signup from './Home/onboarding/signup';
// import Toolbar from './layout/toolbar_replace';
import Toolbar from './layout/toolbar_fresh';
import Error from './errorHandling/errorModal';
import OnboardingStep1 from './Home/onboarding/onboardingStep1';
import EditInterests from './Home/onboarding/edit-interests';
import OnboardingStep2 from './Home/onboarding/onboardingStep2'
import OnboardingStep3 from './Home/onboarding/onboardingStep3'
import EmailVerified from './Home/onboarding/emailVerified'
import Artist from './artist/artist'
import ArtistDetails from './artist/artist_details'
import TestDate from './artist/testDate'
import UploadImage2 from './Home/profile/uploadImageReplacement'
import YourOrders from './orders/yourOrders'
import OrderDetails from './orders/orderDetails'
import Artworks from './Home/profile/artworks'
import ArtistsList from './Home/profile/artist_list'
// import Header from './layout/header'
import MyProfile from './artist/myProfile'
import Requests from './requests/myRequests'
import ProductDetails from './products/ownProductShow'
import ProductDetailsCategory from './products/categoryWiseProductsPage'
import Categorylist from './products/categoryList'
import SearchPage from './Home/profile/search/searchPage'
import SearchPageArtworks from './Home/profile/search/searchPageArtworks'
import SearchPageArtists from './Home/profile/search/searchPageArtists'
import EditProfile from './Home/profile/editProfile'
import Addresses from './Home/profile/addresses'
import ArtworkCard from './cardHolders/artworksCard'
// import EmailNotVerified from './modals/email-not-verified-modal'
import RequestConfirmed from './requests_modals/request_confirmed'
import TermsConditions from './static/terms-and-conditions'
import Support from './static/support'
import PrivacyPolicy from './static/privacy-and-policy'
import FAQS from './static/faqs'
import PlaceBuyRequest from './requests_forms/place-buy-request'
import RequestAccepted from './requests_modals/request_accepted'
import RequestDeclined from './requests_modals/request_declined'
import RequestRescheduled from './requests_modals/request_rescheduled'
import AcceptBuyRequest from './requests_forms/accept-buy-request'
import PaymentDetails from './requests_forms/payment-details'
import ConfirmBuyRequest from './requests_forms/confirm-buy-request'
import DeclineBuyRequestBuyer from './requests_forms/decline-buy-request-buyer'
import DeclineBuyRequestArtist from './requests_forms/decline-buy-request-artist'
import ForgotPW from './Home/onboarding/resetPassword/forgotPassword'
import UpdatePw from './Home/onboarding/resetPassword/updatePassword'
import EmailSent from './Home/onboarding/resetPassword/email_sent'
import OB2 from './Home/onboarding/onboarding2-modal'
import OB3 from './Home/onboarding/onboarding3-modal'
import OB1 from './Home/onboarding/onboarding1-modal'
import InputPW from './Home/onboarding/resetPassword/inputPassword'
import UpdatePWSec from './Home/onboarding/resetPassword/changePWDSecurity'
import ArtworkNotAvailable from './products/artwork-not-available'
import HowToSell from './static/how-to-sell'
import EveryonePlatform from './static/platform-for-everyone'
import LandingModal from './static/landingModal'
import OldArtworkPatterns from './static/old-artwork-urls'
import OldArtistPatterns from "./static/old-artist-urls";


// import { Redirect, Link } from 'react-router-dom';
// import Modal from 'react-bulma-components/lib/components/modal';
// import 'bootstrap/dist/css/bootstrap.css'
import { Redirect } from 'react-router-dom';
import Agent from '../api/agent'
import agent from '../api/agent';

var loggedOut = false;
@inject('userStore', 'commonStore', 'authStore', 'generalStore', "navigatorStore")
@withRouter
@observer
export default class App extends React.Component {

    // componentWillMount() {
    //     if (this.props.commonStore.token) {
    //         this.props.commonStore.setAppLoaded();
    //     }
    // }

    currentPath = '';
    lastPathList = [];

    pathScrollPositionMap = {
        'paintings': 99
    }

    // componentDidUpdate() {
    //     if (window.localStorage.hasOwnProperty("userData")) {
    //         this.props.userStore.pulluser().then((result) => {
    //             console.log("{this is pulled user}", result)
    //             result.data[0]

    //             // if (!result.data[0].interests) {
    //             //     console.log("interests null")
    //             //     this.props.authStore.makeOnboardingOneIncomplete()
    //             // }
    //             // if (!result.data[0].preferences) {
    //             //     console.log("preferences null")
    //             //     this.props.authStore.makeOnboardingTwoIncomplete()
    //             // }
    //             if (!result.data[0].full_name ||
    //                 !result.data[0].country ||
    //                 //  !response.data.user_profile[0].full_name || 
    //                 //  !response.data.user_profile[0].user.email || 
    //                 //  !response.data.user_profile[0].display_name || 
    //                 !result.data[0].display_name ||
    //                 result.data[0].display_name.length >= 30 ||
    //                 !result.data[0].primary_email ||
    //                 !result.data[0].preferred_currency

    //             ) {
    //                 console.log("profile null")
    //                 this.props.authStore.makeOnboardingThreeIncomplete()
    //             }
    //             else
    //                 this.loginErr = false
    //         }
    //             // this.props.commonStore.setAppLoaded()


    //         )
    //     }
    // }

    componentWillMount() {
        this.unlisten = this.props.history.listen((currentLocation, action) => {
            //console.log("lastPaths  on route change ", currentLocation);
            this.currentPath = currentLocation.pathname.split("/")[1]
            // let lastLocation = this.props.location;
            // var lastPath = lastLocation.pathname.split("/")[1]
            this.lastPathList.push(this.currentPath);

            //this.pathScrollPositionMap[this.currentPath] = 0;
            //   console.log('lastPaths = ', { lastPathList: this.lastPathList, pathScrollPositionMap: this.pathScrollPositionMap });
            // console.log('this.pathScrollPositionMap[this.currentPath] = ', this.pathScrollPositionMap[this.currentPath]);
            if (this.lastPathList.length > 2 && this.lastPathList[this.lastPathList.length - 3] == this.currentPath) {
                // this path was visited before latest path, means this scenario is detected  A->B->A 
                //  console.log("should scroll now")
                /* window.setTimeout(() => {
                     window.scrollTo(0, this.pathScrollPositionMap[this.currentPath]);
                 }, 5000)*/
            } else {
                // This path is lately unvisited
                //window.scrollTo(0, 0);
            }
            /* Handle for ABCBA  */
        });
    }

    manageScrollPositionTick = () => {
        /*console.log('lastPaths TICK = ', { lastPathList: this.lastPathList, pathScrollPositionMap: this.pathScrollPositionMap })
        let currentScroll = document.getElementsByTagName('body')[0].getBoundingClientRect().top;
        this.pathScrollPositionMap[this.currentPath] = currentScroll;
*/
    }

    componentWillUnmount() {
        this.unlisten();
        //document.removeEventListener('scroll', this.manageScrollPositionTick);
    }

    componentDidMount() {
        /* document.addEventListener("contextmenu", function (e) {
             e.preventDefault();
         }, false);*/
        // window.scrollTo(0, 0);
        if (
            !window.location.href.includes("artworks") &&
            !window.location.href.includes("artist") &&
            !window.location.href.includes("category") &&
            !window.location.href.includes("product") &&
            !window.location.href.includes("profile") &&
            !window.location.href.includes("search") &&
            !window.location.href.includes("details") &&
            !window.location.href.includes("edit") &&
            !window.location.href.includes("privacy-and-data-policy") &&
            !window.location.href.includes("terms-and-conditions") &&
            !window.location.href.includes("support") &&
            !window.location.href.includes("faq") &&
            !window.location.href.includes("how-to-sell") &&
            !localStorage.hasOwnProperty("landingModal") &&
            !window.location.href.includes("onboarding") 

        ) {
            //this.props.navigatorStore.openLandingModal();
            //localStorage.setItem("landingModal", true)
        }
        // console.log("changes are now reflected again");
        if (window.localStorage.hasOwnProperty("userData")) {
            this.props.userStore.pulluser().then((result) => {
                console.log("{this is pulled user}", result)
                var url = result.data[0].share_url

                localStorage.setItem("country", result.data[0].country)
                // localStorage.setItem("email", result.data[0].country)
                this.props.commonStore.setAppLoaded()
                // toast.configure()
            });

            // Agent.generalData.listOfMediums()
            //     .then((res) => {
            //         var MediumChoices = [];
            //         console.log("list of mediums", res)
            //         res.data.data.forEach((el, idx) => {
            //             MediumChoices.push({
            //                 "display": el.material,
            //                 "key": el.id
            //             })
            //         })
            //         console.log("medium choices look like this", MediumChoices)
            //         this.props.generalStore.setMediumAndBaseChoices(MediumChoices)
            //     }

            //     );
            // Agent.generalData.listOfBases()
            //     .then((res) => {
            //         console.log("list of mediums", res)
            //     }

            //     )
        }
        else {
            this.props.commonStore.setAppLoaded();
            // toast.configure()
            loggedOut = true;

        }
        //document.addEventListener('scroll', this.manageScrollPositionTick);
    }

    componentWillReceiveProps() {
        if (loggedOut) {
            //console.log("med it renders again");
            if (localStorage.hasOwnProperty("userData")) {
                // Agent.generalData.listOfMediums()
                //     .then((res) => {
                //         console.log("list of mediums", res)
                //     }

                //     );
                // Agent.generalData.listOfBases()
                //     .then((res) => {
                //         console.log("list of mediums", res)
                //     }

                //     )
                loggedOut = false;
            }
        }
    }

    render() {
        // console.log("{location}", this.props.location)
        // console.log("{locarion}" ,  this.props.location)

        //console.log("onboarding complete?", this.props.authStore.onboardingOneIncomplete)


        if (this.props.commonStore.appLoaded) {
            // console.log(route )
            return (
                <div>
                    <Toolbar />

                    <div className="filler-for-navbar"></div>
                    {/* <Route render={({ location }) => (
                            <TransitionGroup>
                        <CSSTransition
                        key={location.key}
                        timeout={450}
                        classNames="fade"
                    > */}
                    {/* Toolbar<br/> */}
                    <div className="loader-container" style={{
                        display: (this.props.commonStore.loadingProgress) ? "" : "none",
                        height: "-webkit-fill-available", width: "-webkit-fill-available",
                        zIndex: 99, position: "fixed", backgroundColor: "white", overflow: "visible"
                    }}>
                        {/* <div className="gray-category-description">Publishing your {(this.props.commonStore.loadingProgressForArtwork) ? "Artwork" : "Image"}, wait for confirmation screen.</div> */}
                        <p className="empty-canvas-text mt-5">
                            Publishing your {(this.props.commonStore.loadingProgressForArtwork) ? "Artwork" : "Image"}, wait for confirmation screen.
                                        </p>
                        <div className="position-loader">
                            {/* Publishing your artwork, wait for confirmation screen. */}

                            <CircularProgressbar value={(this.props.commonStore.completeProgress) ? "100" : this.props.commonStore.loadingPercent} text={(this.props.commonStore.completeProgress) ? "100%" : `${this.props.commonStore.loadingPercent}%`} />
                            {/* <Progress percent={90} status="success"  />
                              <Line percent={(this.props.commonStore.completeProgress) ? "100" : this.props.commonStore.loadingPercent || 80} strokeWidth="4" strokeColor="#D3D3D3" /> */}
                        </div>
                    </div>
                    <div className="loader-container" style={{
                        display: (this.props.commonStore.loading) ? "" : "none",
                        height: "-webkit-fill-available", width: "-webkit-fill-available",
                        zIndex: 99, position: "fixed", backgroundColor: "white", overflow: "visible"
                    }}>
                        <div className="position-loader">

                            <Loader
                                type="Rings"
                                color="#BEA57C"
                                height="100"
                                height="100"
                                width="100"
                            />
                        </div>
                    </div>
                    <ScrollMemory />
                    <Error />
                    {/*<LandingModal />*/}

                    {/* <BrowserRouter>
                        <div> */}

                    {/* <Router> */}
                    <Switch >
                        {/* <Route path="/:userId" component={Home} /> */}
                        {/* <Route path="/apple-app-site-association" component={IOSAPPID} /> */}
                        {/* <Route path="/confirmBuy/:userId/:orderId" component={ConfirmBuy} /> */}
                        <Route path="/signin" component={Login} />
                        <Route path="/signup" component={Signup} />
                        <Route path="/updatePWSec" component={UpdatePWSec} />
                        <Route path="/OB3" component={OB3} />
                        <Route path="/OB1" component={OB1} />
                        <Route path="/OB222" component={OB2} />
                        <Route path="/onboardingone" component={OnboardingStep1} />
                        <Route path="/onboardingtwo" component={OnboardingStep2} />
                        <Route path="/edit-style-preferences" component={OnboardingStep2} />
                        <Route path="/onboardingthree" component={OnboardingStep3} />
                        <Route path="/edit-profile" component={EditProfile} />
                        <Route path="/edit-interests" component={EditInterests} />
                        <Route path="/addresses" component={Addresses} />
                        {/* <Route path="/artworkcard" component={ArtworkCard} /> */}
                        <Route path="/uploadimage2/:artwork_id" component={UploadImage2} />
                        <Route path="/uploadimage2/" component={UploadImage2} />
                        <Route path="/orders" component={YourOrders} />
                        <Route path="/orderdetails" component={OrderDetails} />
                        <Route path="/artworks" component={Artworks} />
                        <Route path={`/profile/details/${localStorage.getItem("username")}`} component={MyProfile} />
                        <Route path="/artists" component={Artist} />
                        <Route path="/allartists/country/:search/:title" component={ArtistsList} />
                        {/* <Route path="/allartists/:search" component={ArtistsList} /> */}
                        <Route path="/allartists/:search/:title/:medium" component={ArtistsList} />
                        <Route path="/allartists/:search/:title" component={ArtistsList} />
                        {/* <Route path="/allartists/technique/:search/:title" component={ArtistsList} /> */}
                        <Route path="/profile/details/:id" component={ArtistDetails} />
                        <Route path="/Searchpage/:search" component={SearchPage} />
                        <Route path="/Searchpage_artworks/category_/:search" component={SearchPageArtworks} />
                        <Route path="/Searchpage_artworks/:search" component={SearchPageArtworks} />
                        <Route path="/Searchpage_artists/:search" component={SearchPageArtists} />
                        <Route path="/product/details/:id" component={ProductDetails} />
                        <Route path="/categorypoducts/:category/:title" component={ProductDetailsCategory} />
                        <Route path="/categorylist/:catId/:title" component={Categorylist} />
                        <Route path="/requests" component={Requests} />
                        <Route path="/testdate" component={TestDate} />
                        {/*<Route path="/email-not-verified" component={EmailNotVerified}/>*/}
                        <Route path="/requestconfirmed" component={RequestConfirmed} />
                        <Route path="/requestaccepted" component={RequestAccepted} />
                        <Route path="/requestdeclined" component={RequestDeclined} />
                        <Route path="/requestrescheduled" component={RequestRescheduled} />
                        <Route path="/accept-buy-request" component={AcceptBuyRequest} />
                        <Route path="/verify-email/:key" component={EmailVerified} />
                        <Route path="/confirm-buy-request" component={ConfirmBuyRequest} />
                        <Route path="/decline-buy-request-buyer" component={DeclineBuyRequestBuyer} />
                        <Route path="/decline-buy-request-artist" component={DeclineBuyRequestArtist} />
                        <Route path="/place-buy-request/:artworkid" component={PlaceBuyRequest} />
                        <Route path="/paymentdetails" component={PaymentDetails} />
                        <Route path="/Forgotpw/:key" component={InputPW} />
                        <Route path="/Forgotpassword" component={ForgotPW} />
                        <Route path="/updatepassword" component={UpdatePw} />
                        <Route path="/terms-and-conditions" component={TermsConditions} />
                        <Route path="/support" component={Support} />
                        <Route path="/privacy-and-data-policy" component={PrivacyPolicy} />
                        <Route path="/how-to-sell" component={HowToSell} />
                        <Route path="/platform-for-everyone" component={EveryonePlatform} />
                        <Route path="/faqs" component={FAQS} />
                        <Route path="/emailsent" component={EmailSent} />
                        <Route path="/artwork-not-available" component={ArtworkNotAvailable} />
                        <Route path="/err" component={Error} />
                        <Route path="/Paintings/painting_details.php" component={OldArtworkPatterns}/>
                        <Route path="/Artist/artist_details.php/" component={OldArtistPatterns}/>
                        {/* <Route path="/toolbar_replace" component={Toolbar_replace} /> */}
                        <Route history={createBrowserHistory} exact path="/" component={LandingPage} />


                    </Switch>
                    {/* </Router> */}
                    {/* </div>
                    </BrowserRouter> */}
                    {/* </CSSTransition>
                        </TransitionGroup>
                    )} /> */}
                    <Footer />
                </div>
            );
        }
        return <div style={{ marginLeft: "50%", marginTop: "20%" }}>


            <Loader
                type="Rings"
                color="#BEA57C"
                height="100"
                width="100"
            />
        </div>
    }
}



// WEBPACK FOOTER //
// ./src/components/App.js